module.exports = __webpack_public_path__ + "static/media/V2_09.01ac200b.png";